import React, { Component } from 'react';
import AppLink from './AppLink'
import { Link } from 'react-router-dom';

export default class FooterMenu extends Component {
  render() {
    const {
      isApp
    } = this.props;
    return (
      <div className="footerMenu" >
        <ul className="menuList">
          <li>
            <AppLink isApp={isApp} to='/about'>Om Fristberegneren</AppLink>
          </li>
          <li>
            <AppLink isApp={isApp}  to='/terms'>Vilkår og betingelser</AppLink>
          </li>
          {!isApp &&
            <li><a href="https://geo.itunes.apple.com/dk/app/fristberegneren/id1072097392?mt=8"
              target="_blank">Download Fristberegneren til iOS</a></li>
          }
          {!isApp &&
            <li><a
              href="https://play.google.com/store/apps/details?id=dk.kammeradvokaten.fristberegneren"
              target="_blank">Download Fristberegneren til Android</a></li>
          }
          <li>
            <a
              href="https://kammeradvokaten.dk/om-firmaet/saadan-haandterer-vi-dine-personoplysninger"
              target="_blank"
              rel="noopener noreferrer"
            >
              Personoplysninger
                  </a>
          </li>
          <li>
            <a
              href="https://kammeradvokaten.dk/personer/niels-karl-heilskov-rytter"
              target="_blank"
              rel="noopener noreferrer"
            >
              Kontakt
                  </a>
          </li>

          {!isApp &&
            (
              <li>
                <a
                  href="javascript:CookieConsent.renew();"
                >
                  Cookies og ændring af samtykke
                </a>
              </li>
            )
          }
                
        </ul>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/FooterMenu.js